import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import BoxButton from '@/components/@IntranetLibrary/Button/BoxButton';
import SerpContentSnapshot from '@/components/Approval/@components/SerpContentSnapshot';
import type { ElementTransform } from '@/components/Common/HtmlToReact';
import { useGetMyInfo } from '@/hooks/apiHooks';
import { useSnackbar } from '@/hooks/global-tools';
import {
  buildSupplierEvaluationDetailUrl,
  openSupplierEvaluationDetail,
} from '@/utils/approval/supplierEvaluation';
import { DETAIL_BUTTON_CLASS } from './content';
import { SupplierEvaluationRoot } from './styles';

export { buildSupplierEvaluationContentHtml } from './content';

/** 저장 본문 그대로(레거시 문서 포함). 「상세보기」는 보는 사람 ID로 ERP 상세 화면을 새 창으로 */
export const SupplierEvaluationSnapshot = ({
  content,
}: {
  content: string;
}) => {
  const { t } = useTranslation();
  const snackbar = useSnackbar();
  const { data: me } = useGetMyInfo();
  const viewerId = me?.loginId;

  const transform = useCallback<ElementTransform>(
    ({ element }) => {
      if (!element.classList.contains(DETAIL_BUTTON_CLASS)) return undefined;
      const detailUrl = element.getAttribute('data-detail-url');
      const appId = element.getAttribute('data-app-id');
      const legacyApprovalId = element.getAttribute('data-aprv_id');
      if (!detailUrl && !appId && !legacyApprovalId) return null;
      const handleClick = () => {
        const url = buildSupplierEvaluationDetailUrl({
          detailUrl,
          appId,
          legacyApprovalId,
          viewerId,
        });
        if (url) openSupplierEvaluationDetail(url);
        else
          snackbar.showError({ message: t('데이터를 불러오지 못했습니다.') });
      };
      return (
        <BoxButton
          type="button"
          variant="secondary"
          size="small"
          onClick={handleClick}
        >
          {t('상세보기')}
        </BoxButton>
      );
    },
    [snackbar, t, viewerId],
  );

  return (
    <SupplierEvaluationRoot>
      <SerpContentSnapshot content={content} transform={transform} />
    </SupplierEvaluationRoot>
  );
};
